module.exports = __webpack_public_path__ + "img/PBS_0308.fb656eb7.jpg";